const moment = require("moment")

module.exports = {
  storeStatus: {
    1: { name: "审核通过", class: "success", icon: "anyteachicon anyteach-check-circle", desc: "已为您开通后台账号" },
    2: { name: "正在审核", class: "review", icon: "anyteachicon anyteach-clock1", desc: "感谢您的合作意向，请等待后台开通", note: "请留意短信通知，账号密码可与店内员工分享" },
  },
  filters: {
    date: function (value) {
      return moment(value).format("YYYY-MM-DD")
    }
  }
}
